export interface UploadFile {
    fileName: string;
    size: number;
    status: UploadFileStatusEnum;
    errorKey: string | null;
    anhangId:string | null;
}

export enum UploadFileStatusEnum {
    LOADING = 'loading',
    ERROR = 'error',
    SUCCESS = 'success'
}